import React from "react";
import styled from "styled-components";
import { fonts } from "theme/fonts";
// import { firebase } from "Components";
// import { useDocumentData } from "react-firebase-hooks/firestore";

export const PoweredBy = ({ zipCode }) => {
  // const [dealer, loading, error] = useDocumentData(
  //   firebase.firestore().doc(`geo/ford/fdaf/${zipCode}`)
  // );

  // if (loading || !zipCode) return null;

  return (
    <PoweredByContainer>
      <PoweredByTitle>Presentado por</PoweredByTitle>
      <PoweredByDealer>
        {/* Your {dealer ? dealer?.fdaf : "Local Ford"} Dealers */}
        Tus Concesionarios Ford de Tejas
      </PoweredByDealer>
    </PoweredByContainer>
  );
};

const PoweredByContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  text-align: center;
`;

const PoweredByTitle = styled.p`
  color: #4580dd;
  font-size: 18px;
  font-family: ${fonts.brandMedium};
  margin: 0;
  margin-bottom: 5px;
`;

const PoweredByDealer = styled.p`
  font-size: 24px;
  font-family: ${fonts.brandMedium};
  margin: 0;
`;
